import { combineReducers } from "redux";

import dictionariesReducer from "./dictionaries/reducer";
import createLlamaReducer from "./create-llama/reducer";
import mediaAudioReducer from "./media-audio/reducer";
import mediaVideoReducer from "./media-video/reducer";
import showStickerItemReducer from "./sticker-show/reducer";
import entitiesReducer from "./entities/reducer";
import mediaPhotoReducer from "./media-photo/reducer";
import draftsReducer from "./drafts/reducer";

export default combineReducers({
  dictionaries: dictionariesReducer,
  createLlama: createLlamaReducer,
  showLlama: showStickerItemReducer,
  mediaAudio: mediaAudioReducer,
  mediaVideo: mediaVideoReducer,
  mediaPhoto: mediaPhotoReducer,
  drafts: draftsReducer,
  entities: entitiesReducer
});
